import {
  type CommerceMapperContext,
  type Commerce,
  ProductCategorie,
  ProductType,
} from '@analytics/models';
import {
  analyticsRoundNumericValue,
  AnalyticsUtils,
  defaultCommerceMapperContext,
  parseTrackProductConfig,
} from '@analytics/utils';
import { inject, Injectable } from '@angular/core';
import type { StoreProductData } from '@legacy/common-ui-models';

@Injectable({
  providedIn: 'root',
})
export class StoreProductTrackingConfig {
  readonly #analyticsUtils = inject(AnalyticsUtils);

  static mapToCommerce = (
    product: StoreProductData,
    context: CommerceMapperContext = defaultCommerceMapperContext,
    productType?: ProductType | string,
    productCategory?: ProductCategorie | string
  ): Commerce => ({
    productNaam: product?.content?.title ?? '',
    productID: product.suiteCrmId,
    productType: productType ?? ProductType.Unknown,
    productCategorie: productCategory ?? ProductCategorie.Unknown,
    productPositie: `${context.index}`,
    productAantal: `${context.numberOfProducts}`,
    productLijst: context.listName,
    prijs: analyticsRoundNumericValue(product.price),
  });

  getConfig = (productType?: string, productCategory?: string) =>
    parseTrackProductConfig({
      productToCommerce: (
        product: StoreProductData,
        context: CommerceMapperContext
      ): Commerce => {
        context = {
          ...context,
          listName: this.#analyticsUtils.prefixWithAbbreviation(
            context.listName
          ),
        };
        return StoreProductTrackingConfig.mapToCommerce(
          product,
          context,
          productType,
          productCategory
        );
      },
    });
}
